import {Injectable} from '@angular/core';
import {SessionStorageService} from '@dcp/configurator';

@Injectable({
  providedIn: 'root',
})
export class CardPaymentSessionStorageService {
  private readonly CVV_PREFIX = 'paymentTokenize_';
  private readonly CONSIGNMENT_AUTHORIZE_JWT_PREFIX: string = 'consignment-authorize-jwt-';
  private readonly CONSIGNMENT_MERCHANT_ID_PREFIX: string = 'consignment-merchant-id-';
  private readonly CONSIGNMENT_THREE_DS_REQUIRED_PREFIX: string = 'consignment-three-ds-required-';

  constructor(private sessionStorageService: SessionStorageService) {}

  public setCvv(token: string, cvv: string) {
    this.sessionStorageService.setItem(`${this.CVV_PREFIX}${token}`, cvv);
  }

  public getCvv(token: string): string | null {
    return this.sessionStorageService.getItem(`${this.CVV_PREFIX}${token}`);
  }

  public setAuthorizeJwt(consignmentCode: string, jwt: string) {
    this.sessionStorageService.setItem(`${this.CONSIGNMENT_AUTHORIZE_JWT_PREFIX}${consignmentCode}`, jwt);
  }

  public getAuthorizeJwt(consignmentCode: string): string | null {
    return this.sessionStorageService.getItem(`${this.CONSIGNMENT_AUTHORIZE_JWT_PREFIX}${consignmentCode}`);
  }

  public setMerchantId(consignmentCode: string, merchantId: string) {
    this.sessionStorageService.setItem(`${this.CONSIGNMENT_MERCHANT_ID_PREFIX}${consignmentCode}`, merchantId);
  }

  public getMerchantId(consignmentCode: string): string | null {
    return this.sessionStorageService.getItem(`${this.CONSIGNMENT_MERCHANT_ID_PREFIX}${consignmentCode}`);
  }

  public setThreeDSRequired(consignmentCode: string, isThreeDSRequired: boolean) {
    this.sessionStorageService.setItem(
      `${this.CONSIGNMENT_THREE_DS_REQUIRED_PREFIX}${consignmentCode}`,
      String(isThreeDSRequired)
    );
  }

  public getThreeDSRequired(consignmentCode: string): boolean | null {
    return (
      this.sessionStorageService.getItem(`${this.CONSIGNMENT_THREE_DS_REQUIRED_PREFIX}${consignmentCode}`) === 'true'
    );
  }

  /**
   * remove all authorize jwt and cvv items from sessionStorage
   */
  public clear(): void {
    this.clearCvv();
    this.clearAuthorizeJwt();
  }

  /**
   * remove all cvv items from sessionStorage
   */
  public clearCvv() {
    this.sessionStorageService.removeSessionStorageItemsByPrefix(this.CVV_PREFIX);
  }

  /**
   * remove all authorize jwt items from sessionStorage
   */
  public clearAuthorizeJwt() {
    this.sessionStorageService.removeSessionStorageItemsByPrefix(this.CONSIGNMENT_AUTHORIZE_JWT_PREFIX);
  }
}
